export { getPermissionsAdapter } from './permissions-adapter'
